import { Button, DataSource, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutlayout_diuser extends Layout {
    buttonButton1: Button;
    mobileXrefButton: Button;
    sendMobileLinkButton: Button;
    sourceDigroup: DataSource;
    sourceDiuser2: DataSource;
    sourceDiuser: DataSource;
    tbDigroupDesc: Textbox;
    tbDigroupGid: Textbox;
    tbDigroupType: Textbox;
    tbDiuserLogin: Textbox;
    tbDiuserUid: Textbox;
    textboxDigroupType: Textbox;
    textboxDiuserBdate: Textbox;
    textboxDiuserCdate: Textbox;
    textboxDiuserEmail: Textbox;
    textboxDiuserFailcnt: Textbox;
    textboxDiuserFax: Textbox;
    textboxDiuserFullname: Textbox;
    textboxDiuserGid: Textbox;
    textboxDiuserLadate: Textbox;
    textboxDiuserLmeuid: Textbox;
    textboxDiuserLogin: Textbox;
    textboxDiuserPasswd: Textbox;
    textboxDiuserPhone: Textbox;
    textboxDiuserStatus: Textbox;
    textboxDiuserUid: Textbox;
}
